import { render, staticRenderFns } from "./MessageKey.vue?vue&type=template&id=56f579bb&scoped=true"
import script from "./MessageKey.vue?vue&type=script&lang=js"
export * from "./MessageKey.vue?vue&type=script&lang=js"
import style0 from "./MessageKey.vue?vue&type=style&index=0&id=56f579bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f579bb",
  null
  
)

export default component.exports